import React, { useState } from 'react';
import { Box } from '@mui/material';
import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Swiper, SwiperSlide } from 'swiper/react';

// import { EffectCube, EffectFade, Controller, Mousewheel, Autoplay } from 'swiper/modules';
// import { Mousewheel, Autoplay } from 'swiper/modules';

// import 'font-face';
// import { Swiper, SwiperSlide } from 'swiper/swiper-react.mjs';

import {
  EffectFade,
  EffectCube,
  Controller,
  Mousewheel,
  Autoplay
} from 'swiper/modules';

// import 'swiper/bundle';

// import '../../css';
import '../../css/swiper-bundle.css';

// import 'swiper/css';
// import 'swiper/css/effect-fade';
// import 'swiper/css/effect-cube';
// import 'swiper/css/controller';

// import 'swiper/css';
// // import 'swiper/swiper.css';
// import 'swiper/css/effect-fade.css';
// import 'swiper/css/effect-cube.css';
// import 'swiper/css/controller.css';

import '../../css/effect-cube.css';
import '../../css/effect-fade.css';
import '../../css/controller.css';


import '../../css/style.css';



// import 'swiper/scss';
// import 'swiper/scss/effect-fade';
// import 'swiper/scss/effect-cube';
// import 'swiper/scss/controller';

import img0 from '../../images/0.png';
import img1 from '../../images/1.png';
import img2 from '../../images/2.png';
import img3 from '../../images/3.png';
import img4 from '../../images/4.png';
import img5 from '../../images/5.png';

export default function Cube() {
  const theme = useTheme();

  const [textSlider, setTextSlider] = useState(null);
  const [cubeSlider, setCubeSlider] = useState(null);

  return (
    <section>
      {/* <Swiper
        modules={[EffectFade, Controller, Mousewheel, Autoplay]}
        onSwiper={(s) => { setTextSlider(s); }}
        controller={{ control: cubeSlider }}
        effect='fade'
        loopspeed={800}
        mousewheel
        autoplay={{
          delay: 4500,
          pauseOnMouseEnter: true,
        }}
        className='text-slider'
      >

        <SwiperSlide>
          <h1>Cube face 0</h1>
        </SwiperSlide>

        <SwiperSlide>
          <h1>Cube face 1</h1>
        </SwiperSlide>

        <SwiperSlide>
          <h1>Cube face 2</h1>
        </SwiperSlide>

        <SwiperSlide>
          <h1>Cube face 3</h1>
        </SwiperSlide>

        <SwiperSlide>
          <h1>Cube face 4</h1>
        </SwiperSlide>

        <SwiperSlide>
          <h1>Cube face 5</h1>
        </SwiperSlide>

      </Swiper> */}

      <Swiper
        modules={[EffectCube, Controller, Mousewheel]}
        // onSwiper={{ setCubeSlider }}
        onSwiper={(s) => { setCubeSlider(s); }}
        // controller={{ control: textSlider }}
        controller={{ control: cubeSlider }}
        effect='cube'
        grabCursor
        loop
        speed={800}
        mousewheel
        // cubeEffect={{
        //   shadow: true,
        //   slideShadows: true,
        //   shadowOffset: 100,
        //   shadowScale: 0.94,
        // }}
        // breakpoints={{
        //   // when window width is >= 300px
        //   300: {
        //     cubeEffect: {
        //       shadowOffset: 60,
        //     },
        //   },
        //   // when window width is >= 600px
        //   600: {
        //     cubeEffect: {
        //       shadowOffset: 100,
        //     },
        //   },
        // }}
        className='cube-slider'
      >
        <SwiperSlide>
          <img src={img0} alt='cube face 0' />
        </SwiperSlide>

        <SwiperSlide>
          <img src={img1} alt='cube face 1' />
        </SwiperSlide>

        <SwiperSlide>
          <img src={img2} alt='cube face 2' />
        </SwiperSlide>

        <SwiperSlide>
          <img src={img3} alt='cube face 3' />
        </SwiperSlide>

        <SwiperSlide>
          <img src={img4} alt='cube face 4' />
        </SwiperSlide>

        <SwiperSlide>
          <img src={img5} alt='cube face 5' />
        </SwiperSlide>

      </Swiper>
    </section >
  );
}